import { render, staticRenderFns } from "./GroupCoverageTable.vue?vue&type=template&id=603be68a&"
import script from "./GroupCoverageTable.vue?vue&type=script&lang=js&"
export * from "./GroupCoverageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports